// Copyright (c) 2026 by Audere

import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

export const getErrorText = (
  error?: FetchBaseQueryError | SerializedError
): string => {
  console.error(error);
  if (error) {
    if ("status" in error) {
      if (typeof error.status === "number") {
        return (
          "HTTP code " +
          error.status +
          ": " +
          ((error.data as any).message ||
            (error.data as any).response_code ||
            "No further information")
        );
      } else if (typeof error.status === "string") {
        return (
          "Error: " + error.status + (error.error ? " - " + error.error : "")
        );
      }
    } else {
      return "Error: " + (error.message ?? "Unknown error");
    }
  }
  return "Unknown error";
};
